/* eslint-disable @typescript-eslint/prefer-nullish-coalescing -- it can come as empty string */
import { mapCanBeSold, mapShade } from '@ori/product-box';
export const mapShadeWithPrice = shade => {
  const {
    productCode,
    hexColors,
    imageUrl
  } = mapShade(shade);
  return {
    name: shade.shadeName ?? '',
    code: shade.productCode,
    shade: {
      productCode,
      hexColors,
      imageUrl,
      canBeSold: mapCanBeSold(shade.labels),
      name: shade.shadeName
    },
    price: {
      currentFormatted: shade.formattedPrice?.price?.priceAfterImmediateDiscount || shade.formattedPrice?.price?.currentPrice || ''
    }
  };
};
//# sourceMappingURL=mapShadeWithPrice.js.map